import { ToiletType } from "@/models/toilet-type";
import { ToiletStatus } from "@/models/toilet-status";

export class Toilet {
    id?: string;
    companyId?: string;
    name?: string;
    toiletType?: ToiletType;
    floor?: string;
    boxesCount?: number;
    gatewayMac?: string;
    gatewayId?: string;
    status?: ToiletStatus;
    floorPlanUrl?: string;

    constructor(params?: Partial<Toilet>) {
        Object.assign(this, params);
    }
}
